
define(
	'Tavanoteam.HazardousProducts.HideHazmatFee'
	, [
		'SC.Configuration'
		, 'underscore'
	]
	, function (
		Configuration
		, _
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {

				var inputParameters = {
					'facet.exclude': 'custitem_is_hazmat_fee',
					'custitem_is_hazmat_fee': 'false'
				};

				_.extend(Configuration.searchApiMasterOptions.Facets, inputParameters);

				_.extend(Configuration.searchApiMasterOptions.itemsSearcher, inputParameters);

				_.extend(Configuration.searchApiMasterOptions.typeAhead, inputParameters);

				_.extend(Configuration.searchApiMasterOptions.relatedItems, inputParameters);

				_.extend(Configuration.searchApiMasterOptions.correlatedItems, inputParameters);

				_.extend(Configuration.searchApiMasterOptions.itemDetails, inputParameters);
			}
		};
	});
